export default __webpack_public_path__ + "static/media/iForfe07_DADO.2569d717.png";